import mixins from 'vue-typed-mixins';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

export default mixins(計画書Mixin).extend({
  name: 'PlbscfReadonlyValue',

  props: {
    value: {
      type: Number,
      default: null,
    },
    unitNotYen: {
      type: String,
    },
    // 単位固定の場合は設定
    fixedUnit: {
      type: Number,
    },
  },

  computed: {
    unit(): number | null {
      return this.fixedUnit === undefined ? this.moneyUnit : this.fixedUnit;
    },
  },
});
